import { render, staticRenderFns } from "./PanelSurvey.vue?vue&type=template&id=efd573da&scoped=true&"
import script from "./PanelSurvey.vue?vue&type=script&lang=js&"
export * from "./PanelSurvey.vue?vue&type=script&lang=js&"
import style0 from "./PanelSurvey.vue?vue&type=style&index=0&id=efd573da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd573da",
  null
  
)

export default component.exports